/*
 * TUMLE: "Køb sammen og spar" (snippets/tumle_bundle.liquid).
 * - Choosing an option marks it and shows its price (and struck-out price)
 *   in the sticky add-to-cart bar.
 * - With the pair chosen, "Læg i kurv" (and the sticky bar's button, which
 *   presses it) is taken over before the cart app (Kaching Cart) sees it:
 *   both products go into the cart in one request, then the app re-reads
 *   the cart and opens it, so the drawer always shows both lines. (Adding the
 *   partner after the app's own add raced it: on a slow line the drawer
 *   could show the first product only.) Alone, the product goes through the
 *   app as usual. The saving comes from a Shopify automatic discount.
 */
(function () {
  if (customElements.get('tumle-bundle')) return;

  customElements.define(
    'tumle-bundle',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', () => this.update());
        this.update();
        // "Læg i kurv" (a click, or the form's submit) reaches this first:
        // snippets/tumle_campaign.liquid listens at the top of <head>,
        // before the cart app, and hands every click and submit over here
        window.tumleBundleIntercept = (event) => {
          var el = document.querySelector('tumle-bundle');
          if (el && el.intercept) el.intercept(event);
        };
      }

      intercept(event) {
        var button;
        if (event.type === 'submit') {
          var form = event.target;
          if (!form.closest || !form.closest('product-form')) return;
          button = form.querySelector('[type="submit"], button[name="add"]');
        } else {
          button = event.target.closest && event.target.closest('product-form [type="submit"], product-form button[name="add"]');
        }
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        var chosen = this.chosen();
        if (!chosen || !chosen.dataset.partnerVariant || !this.getClientRects().length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addPair(button, Number(chosen.dataset.partnerVariant));
      }

      // The chosen option (a pair carries data-partner-variant)
      chosen() {
        var checked = this.querySelector('input:checked');
        return checked ? checked.closest('.tumle_bundle__option') : null;
      }

      update() {
        var chosen = null;
        this.querySelectorAll('.tumle_bundle__option').forEach(function (option) {
          var on = option.querySelector('input').checked;
          option.classList.toggle('is-selected', on);
          if (on) chosen = option;
        });
        var bar = document.querySelector('.tum-sticky-atc');
        if (!chosen || !bar) return;
        var amount = bar.querySelector('[data-price]');
        var compare = bar.querySelector('[data-compare]');
        if (amount) amount.textContent = chosen.dataset.price;
        if (compare) {
          compare.textContent = chosen.dataset.compare || '';
          compare.classList.toggle('is-hidden', !chosen.dataset.compare);
        }
        var suffix = bar.querySelector('[data-suffix]');
        if (suffix) suffix.textContent = ''; // the prices carry their currency
      }

      addPair(button, partner) {
        if (this.busy) return;
        var form = button.closest('product-form').querySelector('form');
        var main = Number(form && form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value);
        if (!main || !partner) return;
        this.busy = true;
        button.setAttribute('aria-busy', 'true');
        var api = window.kachingCartApi;
        if (api && typeof api.openCart === 'function') api.openCart();
        var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: main, quantity: 1 }, { id: partner, quantity: 1 }] }),
        })
          .catch(function () {})
          .then(() => {
            this.busy = false;
            button.removeAttribute('aria-busy');
            if (api && typeof api.refreshCart === 'function') api.refreshCart();
            document.documentElement.classList.remove('tumle_cart-adding');
          });
      }
    }
  );
})();
